export default __webpack_public_path__ + "static/DroneCTF-dfba50616f39ba78e2f0dfe1e9bc2dbc.png";